<section class="container">
<div class="row contact-container gx-0 align-items-stretch">
    <h3>
    {{ "Contact" | translate }} <span>{{ "Us" | translate }}</span>
  </h3>
  <div class="col-12 col-lg-7 left-container d-flex flex-column">
    <div class="left-inner-container flex-grow-1 d-flex flex-column justify-content-between">
      <div>
        <div class="mb-4 d-block d-lg-none text-center">
          <h1>{{ "Let’s Get In Touch, How Can We Help?" | translate }}</h1>
          <p>{{ "Have questions about pricing" | translate }}</p>
        </div>

        <div class="d-none d-lg-block mb-3">
          <h1>{{ "Let’s Get In Touch, How Can We Help?" | translate }}</h1>
          <p>{{ "Have questions about pricing" | translate }}</p>
        </div>
      </div>

      <div class="contact-img-container d-none d-lg-block">
        <img class="contact-img" [src]="contactImage" alt="Contact" />
      </div>

      <div class="mt-4 secondary-color">
        <div class="mb-3" *ngIf="emailpath">
          <i class="bi bi-envelope"></i>
          <span class="ms-2 me-2">{{ emailpath }}</span>
        </div>
        <div class="mb-3" *ngIf="whatsappNumber">
          <i class="bi bi-telephone"></i>
          <span class="ms-2 me-2" dir="ltr">{{ whatsappNumber }}</span>
        </div>
        <div class="mb-3" *ngIf="locations">
          <div *ngFor="let loc of locations" class="d-flex align-items-center mb-1">
            <i class="bi bi-geo-alt-fill"></i>
            <span class="ms-2 me-2">{{ loc | translate }}</span>
          </div>
        </div>
        <div class="mb-3" *ngIf="emails">
          <div *ngFor="let email of emails" class="d-flex align-items-center mb-1">
            <i class="bi bi-envelope"></i>
            <span class="ms-2 me-2">{{ email }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-lg-5 p-0 d-flex">
    <div class="form-container w-100 d-flex flex-column justify-content-center">
     <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label>{{ "Full Name" | translate }}</label>
          <div class="input-container">
            <input type="text" formControlName="fullName" name="name" placeholder="{{ 'Enter your full name' | translate }}" />
            <i class="bi bi-person left-icon"></i>
          </div>
          <div class="text-danger mt-1" *ngIf="fullName?.invalid && fullName?.touched">
            {{ "Please enter a valid name" | translate }}
          </div>
        </div>

        <div class="form-group mt-3">
          <label>{{ "Phone Number" | translate }}</label>
          <div class="input-container">
            <input type="text" formControlName="phoneNumber" name="phone" placeholder="{{ 'Enter your phone number' | translate }}" />
            <i class="bi bi-telephone left-icon"></i>
          </div>
          <div class="text-danger mt-1" *ngIf="phoneNumber?.invalid && phoneNumber?.touched">
            {{ "Please enter a valid phone number" | translate }}
          </div>
        </div>

        <div class="form-group mt-3">
          <label>{{ "Email" | translate }}</label>
          <div class="input-container">
            <input type="email" formControlName="email" name="email" placeholder="{{ 'Enter your email' | translate }}" />
            <i class="bi bi-envelope left-icon"></i>
          </div>
          <div class="text-danger mt-1" *ngIf="email?.invalid && email?.touched">
            {{ "Please enter a valid email" | translate }}
          </div>
        </div>

        <div class="form-group mt-3">
          <label>{{ "Message" | translate }}</label>
          <div class="input-container">
            <textarea formControlName="message" name="message" placeholder="{{ 'Enter your message' | translate }}"></textarea>
            <i class="bi bi-chat-left-text left-icon textarea-icon"></i>
          </div>
          <div class="text-danger mt-1" *ngIf="message?.invalid && message?.touched">
            {{ "Please enter a message of at least 5 characters" | translate }}
          </div>
        </div>

        <button type="submit" class="btn w-100 mt-4">{{ "Send" | translate }}</button>
      </form>

      <div *ngIf="whatsappLink">
        <div class="or-divider my-4 d-flex align-items-center">
          <div class="line flex-grow-1"></div>
          <label class="px-2">{{ "Or" | translate }}</label>
          <div class="line flex-grow-1"></div>
        </div>

        <a [href]="whatsappLink" target="_blank" class="whatsapp-link">
          <button class="contact-btn-modern w-100">
            <img [src]="whatAppPath" alt="WhatsApp" />
            <span>{{ "Contact us via WhatsApp" | translate }}</span>
          </button>
        </a>
      </div>

    </div>
  </div>
</div>
</section>